import { createApp } from 'vue'
import { createStore } from 'vuex'

import App from './App.vue'
// import { Pact } from 'pact-lang-api'
import ENUMS from './components/Enums.js'

var toastidmax = 0
const store = createStore({
    state() {
        if (localStorage.found_nonces == undefined) {
            localStorage.found_nonces = JSON.stringify({})
        }
        var tmp_settings = { GAS_LIMIT: 10000 }
        if (localStorage.settings != undefined) {
            tmp_settings = JSON.parse(localStorage.settings)
        }
        console.log("+++++", tmp_settings)
        var tmp_show_bal = true
        if (localStorage.show_bal != undefined) {
            tmp_show_bal = localStorage.show_bal == 'false' ? false : true
        }

        return {
            current_view: ENUMS.VIEWS.MAIN
            , account_name: undefined
            , chain_id: undefined
            , current_height: -1
            , current_height_time: -1
            , current_height_color: "greenyellow"
            , connection_state: undefined
            , CUR_WAL_NET: undefined
            , mine: {}
            , nfr: {}
            , COAL_MAKER: "k:5a7fd75c8fefbe3d116504004c0e417cc2328a823eff89dd6d3168e5e02b95b0" // TODO set the deploy coal maker
            , view_list_last_seeker: 0
            , mine_cur: -1
            , nfr_cur: -1
            , show_bal: tmp_show_bal
            , found_nonces: JSON.parse(localStorage.found_nonces)
            , last_view_focus: undefined
            , wallet_manager: undefined
            , nft_manager: undefined
            , mine_manager: undefined
            , query_manager: undefined
            , settings: tmp_settings
            , queries_expanded: false
            , balance_update_minterval: undefined
            , list_nfts_seeker: undefined
            , toasts: {}

        }
    },
    mutations: {
        show_waiting_accounts(state) {
            state.current_view = ENUMS.VIEWS.ZELCORE_CONNECT
        }
        , addToast(state, x, tim) {
            if (tim == undefined) tim = 30000
            state.toasts[toastidmax] = x
            setTimeout((x) => {
                state.toasts[x] = undefined
                delete state.toasts[x]

            }, tim, toastidmax);
            toastidmax += 1
        }, removeToast(state, x) {
            state.toasts[x] = undefined
            delete state.toasts[x]
        }
        , changeView(state, viw) {
            history.pushState({}, null, "/");
            if (state.current_view != ENUMS.VIEWS.MINT && viw == ENUMS.VIEWS.MINT) {
                setTimeout(() => {

                    var papsnd = new Audio('/paper.mp3');
                    papsnd.play();
                }, 10);

            }
            state.current_view = viw

            // this.$store.state.current_view = teh_view
        }

    }
})


const app = createApp(App)

// Install the store instance as a plugin
app.use(store)
// app.use(Pact)

app.mount("#app")
